export const grids = {
    "categorie redevances": {
        endpoint: "categories",
        grid: [
            { field: "id", headerText: "ID", width: "100", textAlign: "Center" },
            {
                field: "attributes.name",
                headerText: "Nom",
                width: "80",
                textAlign: "Center",

            },
            {
                field: "attributes.description",
                headerText: "Description",
                width: "80",
                textAlign: "Center",
            },
        ],
    },
    "type usager": {
        endpoint: "types",
        grid: [
            { field: "id", headerText: "ID", width: "100", textAlign: "Center" },
            {
                field: "attributes.name",
                headerText: "Nom",
                width: "80",
                textAlign: "Center",

            },
            {
                field: "attributes.categorie",
                headerText: "Catégorie",
                width: "80",
                textAlign: "Center",
            },
            {
                field: "attributes.description",
                headerText: "Description",
                width: "150",
                textAlign: "Center",
            },
        ],
    },

    "type redevance": {
        endpoint: "types",
        grid: [
            { field: "id", headerText: "ID", width: "70", textAlign: "Center" },
            {
                field: "attributes.name",
                headerText: "Nom",
                width: "80",
                textAlign: "Center",

            },
            {
                field: "attributes.category.data.attributes.name",
                headerText: "Catégorie",
                width: "80",
                textAlign: "Center",
            },
            {
                field: "attributes.description",
                headerText: "Description",
                width: "100",
                textAlign: "Center",
            },
        ],
    },
    systeme: {
        endpoint: "systemes",
        grid: [
            { field: "id", headerText: "ID", width: "100", textAlign: "Center" },
            {
                field: "attributes.name",
                headerText: "Nom",
                width: "90",
                textAlign: "Center",

            },
            {
                field: "attributes.value",
                headerText: "Valeur",
                width: "90",
                textAlign: "Center",
            },
        ],
    },
    bureau: {
        endpoint: "bureaus",
        grid: [
            { field: "id", headerText: "ID", width: "60", textAlign: "Center" },
            {
                field: "attributes.name",
                headerText: "Nom",
                width: "90",
                textAlign: "Center",
            },
            {
                field: "attributes.createdAt",
                headerText: "Date",
                width: "90",
                textAlign: "Center",
            },
        ],
    },
    ville: {
        endpoint: "villes",
        grid: [
            { field: "attributes.name", headerText: "Nom de la ville", width: 80 },
             {
                field: "attributes.createdAt",
                headerText: "Date",
                width: "90",
                textAlign: "Center",
            },
        ],
    },
    commune: {
        endpoint: "communes",
        grid: [
            { field: "attributes.name", headerText: "Nom de la commune", width: 80 },
            { field: "attributes.ville.data.attributes.name", headerText: "Ville", width: 80 },
             {
                field: "attributes.createdAt",
                headerText: "Date",
                width: "90",
                textAlign: "Center",
            },
        ],
    },
    quartier: {
        endpoint: "quartiers",
        grid: [
            { field: "attributes.name", headerText: "Nom du quartier", width: 80 },
            { field: "attributes.commune.data.attributes.name", headerText: "Commune", width: 80 },
            { field: "attributes.ville.data.attributes.name", headerText: "Ville", width: 80 },
             {
                field: "attributes.createdAt",
                headerText: "Date",
                width: "90",
                textAlign: "Center",
            },
        ],
    },
};
